import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { Entity } from '../../models/common';
import {
    getEnvironmentOperationLog,
    getEnvironmentOperationLogError,
    getEnvironmentOperationLogFailed,
    getEnvironmentOperationLogSuccess,
    listEnvironmentOperations,
    listEnvironmentOperationsError,
    listEnvironmentOperationsFailed,
    listEnvironmentOperationsSuccess,
} from '../actions/environment-operation/environment-operation-action-creators';
import { environmentOperationAdapter, environmentOperationLogAdapter } from '../adapters/environment-operation-adapter';
import {
    EnvironmentOperationDataStore,
    EnvironmentOperationsStore,
    EnvironmentOperationStatusStore,
} from '../store/environment-operation-store';
import { getPayload } from '../utilities/payload-action';
import { createIndexedStatusReducer } from './indexed-status-reducer';

export const environmentOperationReducer = combineReducers<EnvironmentOperationsStore>({
    data: createReducer(EnvironmentOperationDataStore(), (builder) => {
        builder
            .addCase(listEnvironmentOperationsSuccess, (store, action) => {
                const { result } = getPayload(action);

                environmentOperationAdapter.setMany(
                    store.operations,
                    result.map((data) => Entity(data.uri, data))
                );
            })
            .addCase(getEnvironmentOperationLogSuccess, (store, action) => {
                const { id, result } = getPayload(action);

                environmentOperationLogAdapter.setOne(store.logUris, Entity(id, result));
            });
    }),

    status: combineReducers<EnvironmentOperationStatusStore>({
        getEnvironmentOperationLog: createIndexedStatusReducer({
            inProgress: getEnvironmentOperationLog,
            error: getEnvironmentOperationLogError,
            failed: getEnvironmentOperationLogFailed,
            success: getEnvironmentOperationLogSuccess,
        }),

        listEnvironmentOperations: createIndexedStatusReducer({
            inProgress: listEnvironmentOperations,
            error: listEnvironmentOperationsError,
            failed: listEnvironmentOperationsFailed,
            success: listEnvironmentOperationsSuccess,
        }),
    }),
});
